import { IContaChatHistorico } from "../../../Interfaces/HelpDesk/ContaChatHistorico/ContaChatHistoricoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function CadastrarContaChatHistoricoService(
    requestBody: IContaChatHistorico
) {
    return Service(
        Axios.post(
            `/helpdesk/contachathistorico/cadastrarcontachathistorico`,
            requestBody
        )
    );
}

export async function DeletarContaChatHistoricoService(
    idContaChatHistorico: number
) {
    return Service(
        Axios.delete(
            `/helpdesk/contachathistorico/deletarcontachathistorico?idContaChatHistorico=${idContaChatHistorico}`
        )
    );
}

export async function GetContaChatHistoricoService(idContaChat: number) {
    return Service(
        Axios.get<Array<IContaChatHistorico>>(
            `/helpdesk/contachathistorico/listarcontachathistorico?idContaChat=${idContaChat}`
        )
    );
}

export async function GetContaChatHistoricoPorTelefoneService(
    nrTelefone: string
) {
    return Service(
        Axios.get<Array<IContaChatHistorico>>(
            `/helpdesk/contachathistorico/listarcontachathistoricoportelefone?nrTelefone=${nrTelefone}`
        )
    );
}
